export const KESIMPULAN_OPTIONS = [
  "PERMOHONAN DIKABULKAN",
  "PERMOHONAN DITOLAK KARENA PEMOHON TIDAK MENJELASKAN TUJUAN DAN KEPENTINGAN PERMOHONANNYA",
  "PERMOHONAN DITOLAK KARENA PEMOHON TIDAK MEMBERIKAN DATA IDENTITAS DIRI ATAU MEMENUHI PERSYARATAN YANG DITENTUKAN OLEH LLDIKTI VII",
  "PERMOHONAN DITOLAK KARENA LLDIKTI TIDAK MEMILIKI DATA YANG DIMINTA",
  "PERMOHONAN DITOLAK KARENA INFORMASI YANG DIMINTA SEHARUSNYA TIDAK DIAJUKAN KEPADA LLDIKTI WILAYAH VII / LLDIKTI BUKAN PEMANGKU TUPOKSI YANG TERKAIT DENGAN PERMOHONAN YANG DIAJUKAN",
  "PERMOHONAN DITOLAK KARENA INFORMASI YANG DIMINTA MERUPAKAN INFORMASI YANG DIKECUALIKAN UNTUK DIPUBLIKASIKAN",
  "PERMOHONAN DITOLAK KARENA INFORMASI YANG DIMINTA BELUM FINAL (MASIH DALAM PROSES / MASIH DINAMIS / BELUM LENGKAP / BELUM DIDOKUMENTASIKAN)",
];

// Isian sisi jawaban (boleh diperbaiki pengelola setelah submit)
export const JAWABAN_KEYS = ["tgl_dijawab", "dokumen_jawaban", "kesimpulan"];

// Batas unggahan: tolak >30MB (rekomendasi 25MB agar unggahan stabil)
export const MAX_FILE = 30 * 1048576;

export function pickFileGuard(file, setter) {
  if (file && file.size > MAX_FILE) {
    return `Ukuran berkas ${Math.round(file.size / 1048576)}MB melebihi batas 30MB. Unggah maksimal 25MB agar stabil.`;
  }
  setter(file);
  return null;
}

export function daysBetween(a, b) {
  if (!a || !b) return null;
  const d = Math.round((new Date(b) - new Date(a)) / 86400000);
  return Number.isNaN(d) ? null : d;
}

export function formatTanggal(iso) {
  if (!iso) return "—";
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}